export default __webpack_public_path__ + "static/RootSans-13Ultra-acc69e89bcde0c3a7226c3b7407b4a6c.woff";